<template>
  <div>
    <el-form
      :model="queryParams"
      :rules="rulesCompanyInfo"
      ref="rulesCompanyInfoOne"
      style="margin-bottom: 0; background-color: #fff; padding: 20px"
    >
      <el-form-item
        label="企业全称："
        prop="companyFullName"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.companyFullName"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="企业简称：" prop="companyName" label-width="130px">
        <el-input
          v-model="queryParams.companyName"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item
        label="企业法人："
        prop="legalRepresentative"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.legalRepresentative"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item
        label="法人手机号："
        prop="legalRepresentativePhone"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.legalRepresentativePhone"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item
        label="经营状态："
        prop="companyOperationalStatus"
        label-width="130px"
      >
        <el-radio-group v-model="queryParams.companyOperationalStatus">
          <el-radio
            v-for="(item, index) in query.companyOperationalStatus"
            :key="index"
            :label="item.label"
          ></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="所在地区：" label-width="130px">
        <EarthAreaSelect
          :country="queryParams.country"
          :province="queryParams.province"
          :city="queryParams.city"
          :region="queryParams.region"
          @searchCountry="searchCountry"
          @searchProvince="searchProvince"
          @searchCity="searchCity"
          @searchArea="searchArea"
        >
        </EarthAreaSelect>
      </el-form-item>

      <el-form-item
        label="详细地址："
        prop="companyAddress"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.companyAddress"
          style="width: 470px"
          type="textarea"
          placeholder="所在街道/村/具体地址"
          resize="none"
          rows="2"
        />
      </el-form-item>

      <el-form-item
        label="成立时间："
        prop="establishmentDate"
        label-width="130px"
      >
        <el-date-picker
          v-model="queryParams.establishmentDate"
          type="date"
          placeholder="选择日期"
          style="width: 470px"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item
        label="一句话介绍："
        prop="companyDescribe"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.companyDescribe"
          style="width: 470px"
          type="textarea"
          resize="none"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="经营范围：" prop="businessScope" label-width="130px">
        <el-input
          v-model="queryParams.businessScope"
          style="width: 470px"
          type="textarea"
          resize="none"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item
        label="行业类别："
        prop="industryCategory"
        label-width="130px"
      >
        <el-input
          v-model="queryParams.industryCategory"
          style="width: 470px"
          type="textarea"
          resize="none"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="所在产业链编号：" label-width="130px">
        <el-input
          v-model="queryParams.chainId"
          style="width: 470px"
          @input="inputSearch"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="所在产业链名称：" label-width="130px">
        <el-input
          v-model="queryParams.supplyChainName"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="所在产业链位置：" label-width="130px">
        <el-input
          v-model="queryParams.supplyChainIndustry"
          style="width: 470px"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item
        label="企业简介："
        label-width="130px"
        prop="companyBriefIntroduction"
      >
        <el-input
          v-model="queryParams.companyBriefIntroduction"
          style="width: 860px"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 11, maxRows: 100 }"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="企业详细介绍：" label-width="130px">
        <el-input
          v-model="queryParams.companyDetailedIntr"
          :autosize="{ minRows: 25, maxRows: 200 }"
          style="width: 860px"
          type="textarea"
          placeholder="请输入"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";
import DicRadioGroup from "@/components/DicRadioGroup.vue";
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import EarthAreaSelect from "@/components/EarthAreaSelect/index.vue";
import DataTime from "@/components/DataTime.vue";

// api
import {
  getClientEnterpriseBaseInfo,
  getChainCode,
  updateBasicInfo,
  insertClientEnterprise
} from "@/api/customCompany.js";
// utils
import { debounce } from "@/utils/index.js";

export default {
  name: "EnterpriseInfo",
  components: {
    UploadImage,
    DicRadioGroup,
    DicCheckboxGroup,
    DataTime,
    EarthAreaSelect
  },
  data() {
    return {
      isLinkShow: false,
      isShow: false,
      query: {
        judgeArray: [
          { label: "是", value: 1 },
          { label: "否", value: 0 }
        ],
        companyOperationalStatus: [
          {
            label: "存续"
          },
          {
            label: "在业"
          },
          {
            label: "其他"
          }
        ],
        socialSecurityNumberArray: [
          {
            label: "10人以下"
          },
          {
            label: "10-15人"
          },
          {
            label: "15-30人"
          },
          {
            label: "30-50人"
          },
          {
            label: "50-100人"
          },
          {
            label: "100-150人"
          },
          {
            label: "150-500人"
          },
          {
            label: "500-1000人"
          },
          {
            label: "1000-2000人"
          },
          {
            label: "2000人以上"
          },
          {
            label: "不明确"
          }
        ]
      },
      queryParams: {
        businessScope: "", // 经营范围
        country: "", // 国家
        province: "", // 省份
        city: "", // 所在城市
        region: "", // 所在区县
        companyAddress: "", // 详细地址
        companyBriefIntroduction: "", // 企业简介
        companyDescribe: "", // 一句话介绍
        companyDetailedIntr: "", // 企业详细介绍
        companyFullName: "", // 企业全称
        companyName: "", // 企业简称
        companyNature: "", // 企业性质
        companyProperty: "", // 企业性质
        companyShortName: "", // 企业简称
        companyOperationalStatus: "", // 经营状态
        establishmentDate: "", // 成立时间
        industryCategory: "", // 行业类别
        legalRepresentative: "", // 法人
        legalRepresentativePhone: "", // 法人手机号
        // 产业链模块
        chainId: "",
        supplyChainName: "", // 所在产业链编号
        supplyChainIndustry: "" // 所在产业链名称
      },
      activeName: "first",
      isShowInput: false,
      searchBarFixed: false,
      saveCompanyLogo: "",
      teamInfoTable: [], // 团队信息数据
      rulesCompanyInfo: {
        companyFullName: [
          { required: true, message: "请输入公司全称", trigger: "blur" }
        ]
      },
      checkList: [], //企业资质数组
      year: "", //认定年份
      disone: false, //专精特新是否禁用
      distwo: false, //专精特新小巨人是否禁用
      leone: false,
      letwo: false,
      le: false,
      checkone: null,
      checktwo: null,
      checkthere: null,

      checked1: "",
      checked2: "",
      checked3: "",
      isInit: false
    };
  },
  computed: {
    companyCode() {
      return this.$route.query.id;
    },
    enterpriseType() {
      return Number(this.$route.query.enterpriseType);
    }
  },
  created() {
    if (!this.enterpriseType) {
      this.isShow = true;
    }
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getClientEnterpriseBaseInfo({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.isInit = true;
          this.queryParams = res.data;
          this.$set(
            this.queryParams,
            "establishmentDate",
            res.data ? res.data.establishmentDate : ""
          );
        }
      });
    },
    inputSearch(e) {
      debounce(this.getChainCode, 800);
    },
    getChainCode() {
      this.$modal.loading("查询中，请稍候...");

      getChainCode({ id: this.queryParams.chainId })
        .then(res => {
          if (res.data && res.data.supplyChainName) {
            this.queryParams.supplyChainName = res.data.supplyChainName;
          } else {
            this.queryParams.supplyChainName = "";
          }

          if (res.data && res.data.supplyChainIndustry) {
            this.queryParams.supplyChainIndustry = res.data.supplyChainIndustry;
          } else {
            this.queryParams.supplyChainIndustry = "";
          }
        })
        .finally(fin => {
          this.$modal.closeLoading();
        });
    },
    submit() {
      // this.$modal.loading("正在保存数据，请稍候...");

      updateBasicInfo(this.queryParams)
        .then(res => {
          if (res.code === 200) {
            // this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    searchCountry(val) {
      this.queryParams.country = val;
    },
    searchProvince(val) {
      this.queryParams.province = val;
    },
    searchCity(val) {
      this.queryParams.city = val;
    },
    searchArea(val) {
      this.queryParams.region = val;
    },
    // 将字符串格式化成数组
    formatString(val) {
      if (!val) {
        return [];
      } else if (!val.length) {
        return val;
      } else {
        return val.split(",");
      }
    },
    editClick() {
      this.isShowInput = true;
    },
    cancelItem() {
      this.$router.go(-1);
    },
    // 改变企业资质
    changeLevel1(val) {
      if (val) {
        this.distwo = true;
        this.le = true;
        this.leone = true;
        this.letwo = true;
      } else {
        this.distwo = false;
        this.le = false;
      }
    },
    // 改变企业资质
    changeLevel2(val) {
      if (val) {
        this.disone = true;
        this.le = true;
        this.leone = false;
        this.letwo = true;
      } else {
        this.disone = false;
        this.le = false;
      }
    },
    // 改变企业资质
    changeLevel3(val) {
      // console.log(val, 3);
    }
  }
};
</script>

<style lang="less" scoped>
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #7c7f8e;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .company_right {
    font-size: 12px;
    color: #7c7f8e;
  }
}
/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
.leave {
  width: 426px !important;
  height: 84px !important;
  padding: 10px 0;
  background: #f5f6f7;
}
</style>
